
import { useContext } from "react";
import { Link } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import { textes } from "../../constants/textes";


export default function Forfait({forfait, position}) {
    // states
    const {user} = useContext(UserContext);


    // comportements


    // Affichage
    return (
        <tr style={{borderStyle: "none"}}>
            <td className="text-center">{position + 1}</td>
            <td>{forfait?.libhotspot}</td>
            <td>
                <div className="d-flex flex-row">
                    <div className="widget-content-left mr-3">
                        <img style={{width: 48, height: 48}} className="rounded" src={forfait.img !== null ? forfait?.img : "/assets/imgs/no-image.png"} alt="" />
                    </div>
                    <div className="widget-content-left">
                        <div className="widget-heading">{forfait?.lib} ({forfait?.libtforfait})</div>
                        <div className="widget-subheading">{forfait?.prof}</div>
                    </div>
                </div>
            </td>
            <td>{forfait?.duree}</td>
            <td>{forfait?.qte}</td>
            <td>{forfait?.prix} XAF</td>
            <td>
                <span 
                    className={`badge ${
                        forfait.etat === 1 ? "badge-success" : 
                        (forfait.etat === 2 || forfait.etat === 10) ? "badge-danger" : 
                        ""
                        } mt-2`
                    } 
                    style={{fontSize: 14}}>
                        {forfait?.etatdef}
                </span>
            </td>
            <td>{forfait?.datecrea.slice(0, 16).replace("T", " à ")}</td>
            <td className="text-center">
                {(user?.isFullAction || user?.isAdminAction || user?.isConsulterForfait) && 
                    <Link to={`/forfait/${forfait?.code}`} data-toggle="tooltip" title={textes.fr.viewforfaitlabel} data-placement="left" className="btn-shadow-primary mr-2 ml-2 btn btn-sm btn-primary">
                        <i className="fa fa-eye"></i>
                    </Link>
                }
            </td>
        </tr>
    )
}